import { render, staticRenderFns } from "./filaAtendimentos.vue?vue&type=template&id=27336784&scoped=true&"
import script from "./filaAtendimentos.vue?vue&type=script&lang=js&"
export * from "./filaAtendimentos.vue?vue&type=script&lang=js&"
import style0 from "./filaAtendimentos.vue?vue&type=style&index=0&id=27336784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27336784",
  null
  
)

export default component.exports